import { useState } from 'react';
import { LEVEL_TAB, VALUES_TAB } from '../constants';

export type MarketDataViewProps = {
  selectedChartTabValue: string;
  selectedGridTabValue: string;
  onChartChange: (value: string) => void;
  onGridChange: (value: string) => void;
};

export const useMarketDataViewState = (): MarketDataViewProps => {
  const [selectedChartTabValue, setSelectedChartTabValue] = useState(LEVEL_TAB);
  const [selectedGridTabValue, setSelectedGridTabValue] = useState(VALUES_TAB);

  const onChartChange = (value: string) => {
    setSelectedChartTabValue(value);
  };

  const onGridChange = (value: string) => {
    setSelectedGridTabValue(value);
  };

  return {
    selectedChartTabValue,
    selectedGridTabValue,
    onChartChange,
    onGridChange,
  };
};
